module.exports = __webpack_public_path__ + "static/the-jobs-of-tomorrow-2b184fac13ed7280800fb6bf386bdebb.png";